import {
  GetShopTheLookSettingsArgs,
  UpdateShopTheLookSettingsPayload,
} from 'src/components-bl/ShopTheLook/Actions/types';
import * as mapper from './mapper';
import * as builder from './builder';
import { ShopTheLookSettingsTypes } from '../types';
import { ApiServiceBase } from '../api-service-base';

export class ShopTheLookGeneralSettings extends ApiServiceBase {
  constructor() {
    super('shops');
  }

  private getUrl({ shopId, variantId }: GetShopTheLookSettingsArgs): string {
    return `${this.serviceBaseUri}/${shopId}/syte-products/shop-the-look/general-settings${
      variantId ? `?variantId=${variantId}` : ''
    }`;
  }

  async get({
    shopId,
    variantId,
  }: GetShopTheLookSettingsArgs): Promise<ShopTheLookSettingsTypes.ShopTheLookSettings> {
    const url = this.getUrl({ shopId, variantId });
    const response = await this.httpService.get({ url });
    return mapper.shopTheLookSettingsResponse(response);
  }

  async update({
    shopId,
    variantId,
    ...payload
  }: UpdateShopTheLookSettingsPayload): Promise<ShopTheLookSettingsTypes.ShopTheLookSettings> {
    const url = this.getUrl({ shopId, variantId });

    const data = builder.buildShopTheLookSettingsPayload(payload);
    const response = await this.httpService.patch({ url, data });
    return mapper.shopTheLookSettingsResponse(response);
  }
}
